import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDragHandle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 14,
	viewBox: "0 0 8 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 1.5,
			r: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.5,
			cy: 1.5,
			r: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 7,
			r: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.5,
			cy: 7,
			r: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.5,
			cy: 12.5,
			r: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.5,
			cy: 12.5,
			r: 1.5,
			fill: "currentColor"
		})
	]
});
export default SvgDragHandle;
